<template>
  <v-app id='app' :dark="dark">
     <v-toolbar v-if="!compact">
      <img src="./assets/logo.jpeg" alt="Music Demixing Challenge" height="100%">
      <v-toolbar-title>Music Demixing (MDX) Challenge 2021</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn @click.stop="dialog = true" text>Admin</v-btn>
      </v-toolbar-items>
    </v-toolbar>
      <v-dialog
      v-model="dialog"
      max-width="400"
      style="z-index: 100000000000"
    >
      <v-card>
        <v-card-title class="headline">Admin View</v-card-title>

        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-text-field
                v-model="accessKeyId"
                label="AWS Access Key"
                required
              ></v-text-field>
            </v-row>
            <v-row>
              <v-text-field
                v-model="secretAccessKey"
                label="AWS Secret Key"
                required
              ></v-text-field>
            </v-row>
            <v-row v-if="publicAccessKeyId == accessKeyId">
              ℹ️ Using guest credentials<br><br>
            </v-row>
            <v-card-actions>
              <v-btn
                color="success"
                class="mr-4"
                v-on:click="saveCredentials"
              >Save</v-btn>
              <v-btn
                class="mr-4"
                v-on:click="resetCredentials"
              >Reset</v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
  <v-container>
    <v-row no-gutters>
        <v-autocomplete v-if="submissions.length > 0 && !(compact && selectedSubmission != null)"
          :dark="dark"
          v-model="selectedSubmission"
          class="select"
          :items="submissions"
          light
          label="Select submission"
          item-text="id"
        >
          <template slot="selection" slot-scope="data">
            {{ data.item.id }}
          </template>
          <template slot="item" slot-scope="data">
            <div style="display: grid">
              <b>
                {{ data.item.id }}
              </b>
              <small>
                SDR: {{ data.item.sdr }}, @{{  data.item.author }}
              </small>
            </div>
          </template>
        </v-autocomplete>
        <v-div v-if="!compact">Currently Selected: {{ selectedSubmission }}</v-div>
        <v-select v-if="tracks.length > 1"
          :dark="dark"
          v-model="selectedTrack"
          class="select"
          :items="tracks"
          light
          label="Select track to separate"
        ></v-select>
      <Player :ref="player" :urls="tracklist" :dark="dark"></Player>
      <v-layout
        align-center
        justify-center
        style="background: red;"
      >
      </v-layout>
    </v-row>
  </v-container>    
  </v-app>
</template>

<script>
import Player from './components/Player.vue'
import axios from 'axios'
import AWS from 'aws-sdk'

const urlParams = new URLSearchParams(window.location.search);

export default {
  name: 'App',
  components: { Player },
  data () {
    return {
      dark: true,
      submissions: [],
      tracks: [],
      tracks_private: [],
      stems: [],
      selectedTrack: '',
      selectedSubmission: urlParams.get('selectedSubmission'),
      compact: urlParams.get('compact') == "true",
      dialog: false,
      baseUrl: process.env.BASE_URL,
      publicAccessKeyId: 'AKIAT4DJUO6QZIEL6YGR',
      accessKeyId: localStorage.getItem('accessKeyId') || 'AKIAT4DJUO6Q5TWNC4OX',
      secretAccessKey: localStorage.getItem('secretAccessKey') || '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'
    }
  },
  mounted: function () {
    this.fetchData();
  },
  created: function () {
    
  },
  methods: {
    fetchData(){
     axios.get(this.baseUrl + 'headers.json').then(response => {
        this.tracks = response.data.tracks
        this.tracks_private = response.data.tracks_private
        this.stems = response.data.stems
        this.selectedTrack = response.data.selected_track
        this.dark = false; //response.data.dark
        if(this.accessKeyId != this.publicAccessKeyId) {
           this.tracks = this.tracks_private;
        }
     })
     axios.get('https://aicrowd-production.s3.eu-central-1.amazonaws.com/misc/music-demixing-challenge/submissions_r2.json').then(response => {
        this.submissions = response.data.submissions
     })
    },
    saveCredentials(close=true) {
      localStorage.setItem('accessKeyId', this.accessKeyId);
      localStorage.setItem('secretAccessKey', this.secretAccessKey);
      if (this.accessKeyId!=this.publicAccessKeyId) {
          this.tracks = this.tracks_private;
      }
      if(close) {
          this.dialog = false;
      }
    },
    resetCredentials() {
      this.accessKeyId = 'AKIAT4DJUO6QZIEL6YGR'
      this.secretAccessKey = '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';
      this.saveCredentials(false);
    },
    gets3client: function() {
      AWS.config.update({
        accessKeyId: this.accessKeyId,
        secretAccessKey: this.secretAccessKey,
        region: 'us-east-1',
        signatureVersion: 'v4'
      });
      const s3 = new AWS.S3()
      return s3
    },
    getSignedURL: function(key) {
      const s3 = this.gets3client()
      const bucket = "sony-evaluation-artifacts"
      const signedUrlExpireSeconds = 600
      const url = s3.getSignedUrl('getObject', {
        Bucket: bucket,
        Key: key,
        Expires: signedUrlExpireSeconds
      });
      return url;
    }
  },
  computed: {
    tracklist: function () {
      var trackstoload = []

      if (this.selectedSubmission == null) {
        console.log("No song selected; Skipping render;")
        return [];
      }

      var currentSubmissionMetadata = this.submissions.filter(x => x.id == this.selectedSubmission);
      if (currentSubmissionMetadata == undefined || currentSubmissionMetadata.length < 1) {
        console.log("Invalid submission id; Skipping render;")
        return [];
      }
      currentSubmissionMetadata = currentSubmissionMetadata[0];
      var s3path = `artifacts/${currentSubmissionMetadata['hash']}//shared/results`

      for (let stem of this.stems) {
        trackstoload.push(
            { 'name': stem,
              'customClass': stem,
              'solo': false,
              'mute': false,
              'src': this.getSignedURL([
                s3path, this.selectedTrack, stem
              ].join('/') + '.wav')
          })
      }
      return trackstoload
    }
  }

}
</script>

<style lang="stylus">
.logo {
  padding: 2em;
}

.logos {
  margin-top: 4em;

}

.select {
  z-index: 1000
}

.theme--dark.application {
    background: #012b56;
}

.theme--light.application {
    background: white;
}

.theme--dark.v-toolbar, .theme--light.v-toolbar {
    background-color: #013367;
    color: white;
}

.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
    background-color: #012b56;
}

.v-icon {
    border-radius: 100%
}

.container {
    max-width: 100%;
}
</style>
